import React, { useState } from 'react';

const DAYS   = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

function toKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// workingDays: array of day-of-week numbers that have staff available (0=Sun…6=Sat)
// Empty array = no restriction (show all days)
export default function StepDate({ onSelect, selected, workingDays = [] }) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [view, setView] = useState(() => {
    const d = selected ? new Date(selected + 'T00:00:00') : new Date();
    return { year: d.getFullYear(), month: d.getMonth() };
  });

  const firstDay    = new Date(view.year, view.month, 1).getDay();
  const daysInMonth = new Date(view.year, view.month + 1, 0).getDate();
  const isPrevDisabled = view.year === today.getFullYear() && view.month === today.getMonth();

  const prevMonth = () => setView(v => { const d = new Date(v.year, v.month - 1, 1); return { year: d.getFullYear(), month: d.getMonth() }; });
  const nextMonth = () => setView(v => { const d = new Date(v.year, v.month + 1, 1); return { year: d.getFullYear(), month: d.getMonth() }; });

  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);

  const hasWorkingDays = workingDays.length > 0;

  return (
    <>
      <div className="w-title">Choose a date</div>
      <div className="w-calendar">
        <div className="w-cal-header">
          <button className="w-cal-nav" onClick={prevMonth} disabled={isPrevDisabled}>‹</button>
          <span className="w-cal-month">{MONTHS[view.month]} {view.year}</span>
          <button className="w-cal-nav" onClick={nextMonth}>›</button>
        </div>
        <div className="w-cal-grid">
          {DAYS.map(d => <div key={d} className="w-cal-dow">{d}</div>)}
          {cells.map((day, i) => {
            if (!day) return <div key={`e-${i}`} className="w-cal-day empty" />;
            const date    = new Date(view.year, view.month, day);
            const dow     = date.getDay();
            const isPast  = date < today;
            const isOff   = hasWorkingDays && !workingDays.includes(dow);
            const key     = toKey(date);
            const isToday = key === toKey(today);
            const isSel   = key === selected;

            return (
              <button
                key={key}
                className={`w-cal-day ${isSel ? 'selected' : ''} ${isToday && !isSel ? 'today' : ''} ${isOff ? 'off' : ''}`}
                disabled={isPast || isOff}
                onClick={() => onSelect(key)}
                title={isOff ? 'Closed' : undefined}
              >
                {day}
              </button>
            );
          })}
        </div>
      </div>
      {hasWorkingDays && (
        <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 6, textAlign: 'center' }}>
          Greyed dates are closed days
        </p>
      )}
    </>
  );
}
